// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Yqt","rootNoMargin":"styles_rootNoMargin__2IOuh"};